import { f as a } from "./index743.mjs";
import { t as n } from "./index756.mjs";
var o = a, s = n, e = o({}.hasOwnProperty), i = Object.hasOwn || function(r, t) {
  return e(s(r), t);
};
export {
  i as h
};
